import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard";
import ProductType from "./Pages/ProductType";
import CardSwipe from "./Pages/CardSwipe";
import Navbar from "./Components/Navbar";

const AppContent = () => {
  const location = useLocation();
const hideNavbar = location.pathname === "/Login" || location.pathname === "/";

  const PageRoutes = (
    <Routes>
        <Route path="/" element={<Login />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/Dashboard" element={<Dashboard />} />
      <Route path="/ProductType" element={<ProductType />} />
      <Route path="/CardSwipe" element={<CardSwipe />} />
    </Routes>
  );     

  // If on login, render only the page (no Navbar)
  if (hideNavbar) {
    return PageRoutes;
  }

  // Otherwise, wrap content with Navbar and pass children
  return <Navbar>{PageRoutes}</Navbar>;
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
